export const getTime = (timeStampSec: string) => {
  return new Date(parseInt(timeStampSec) * 1000);
};

export const isExpired = (endTimestampSec: string): boolean => {
  const end = new Date(parseInt(endTimestampSec) * 1000).getTime();
  const now = new Date().getTime();
  return end < now;
};
